// extracted by mini-css-extract-plugin
export default {"button":"ButtonCSS_button__FXH0u","disabled":"ButtonCSS_disabled__Fq5cL","text":"ButtonCSS_text__RYmIv","circle":"ButtonCSS_circle__3AdvQ","spinner":"ButtonCSS_spinner__CvucW"};